import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { AuthLayout, authButton } from "@/components/auth/AuthLayout";
import { Splash } from "@/components/auth/RouteGuards";
import { authErrorMessage } from "@/lib/authErrors";
import { supabase } from "@/lib/supabase";

const ALLOWED = new Set(["signup", "magiclink", "recovery", "email", "invite"]);
const attempted = new Map(); // token hashes are single-use; never verify the same one twice (StrictMode).

function verifyOnce(tokenHash, type) {
  if (!attempted.has(tokenHash)) attempted.set(tokenHash, supabase.auth.verifyOtp({ token_hash: tokenHash, type }));
  return attempted.get(tokenHash);
}

export default function AuthConfirm() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const tokenHash = params.get("token_hash");
  const type = params.get("type");

  useEffect(() => {
    if (!tokenHash || !ALLOWED.has(type)) {
      setError("This link is incomplete or invalid.");
      return;
    }
    verifyOnce(tokenHash, type).then(({ error: err }) => {
      if (err) {
        setError(authErrorMessage(err));
        return;
      }
      if (type === "recovery") {
        navigate("/reset-password", { replace: true });
      } else {
        toast.success("Email verified. Welcome to ChatSleek.");
        navigate("/", { replace: true });
      }
    });
  }, [tokenHash, type, navigate]);

  if (!error) return <Splash />;
  const recovery = type === "recovery";
  return (
    <AuthLayout testId="auth-confirm-error" title="This link didn't work" subtitle={error}>
      <div className="space-y-3">
        <Link to={recovery ? "/forgot-password" : "/check-email"} className={authButton} data-testid="auth-confirm-request-new">
          {recovery ? "Request a new reset link" : "Resend verification email"}
        </Link>
        <Link to="/sign-in" className="block text-center text-sm text-zinc-400 hover:text-white" data-testid="auth-confirm-sign-in">
          Back to sign in
        </Link>
      </div>
    </AuthLayout>
  );
}
